import Box from "@/components/Box";
import Circle from "@/components/Circle";
import { theme } from "@/core/theme";
import { CMP_LEARNING_HUB_COURSES_URL } from "@/core/urls";
import { COURSE_CONNECTIONS_QUERY } from "@/graphql/knowledgeCenter/webinars";
import useCmpRelatedUrl from "@/hooks/organisations/useCmpRelatedUrl";
import PaperStackIcon from "@/images/PaperStackIcon";
import Group from "@/tpo/Group";
import LinkWrapper from "@/tpo/LinkWrapper";
import Stack from "@/tpo/Stack";
import ButtonV2 from "@/v2/Buttons";
import { useQuery } from "@apollo/client";

import CourseCard from "./CourseCard";
import DashboardCarousel, { DashboardCarouselPanel } from "./DashboardCarousel";
import {
  dashboardActionButtonSize,
  dashboardHeaderIconCircleSize,
  dashboardHeaderIconSize,
  dashboardHeaderRowGap,
  dashboardInnerStackGap,
  dashboardPanelPadding,
  dashboardSectionBody,
  dashboardSectionListMaxItems,
  dashboardSectionTitle,
  learningHubDashboardCarouselInset
} from "./dashboardLayout";

export default function NewestCpdCoursesSection() {
  const { resolvedUrls } = useCmpRelatedUrl();

  const { data, loading } = useQuery(COURSE_CONNECTIONS_QUERY, {
    variables: {
      first: dashboardSectionListMaxItems,
      orderBy: "-exclusive_access_end_time,-pk"
    }
  });

  const courses = data?.courseConnections?.edges?.map(edge => edge.node) ?? [];

  return (
    <Stack
      bg="white"
      borderRadius={20}
      width="100%"
      minWidth={0}
      pt={dashboardPanelPadding.pt}
      pb={dashboardPanelPadding.pb}
    >
      <Stack gap={dashboardInnerStackGap} width="100%" minWidth={0} pb={0}>
        <Group
          alignItems="center"
          justifyContent="space-between"
          flexWrap="wrap"
          gap={dashboardHeaderRowGap}
          px={dashboardPanelPadding.px}
        >
          <Group gap={dashboardHeaderRowGap} alignItems="center" flexWrap="wrap">
            <Circle bg="transparent" size={dashboardHeaderIconCircleSize} border="2px solid black">
              <PaperStackIcon fill={theme.colors.dark} size={dashboardHeaderIconSize} />
            </Circle>
            <Box {...dashboardSectionTitle}>Newest CPD Courses</Box>
          </Group>
          <ButtonV2
            color="dark"
            size={dashboardActionButtonSize}
            as={LinkWrapper}
            to={resolvedUrls[CMP_LEARNING_HUB_COURSES_URL]}
          >
            see all
          </ButtonV2>
        </Group>
        {!loading && !courses.length && (
          <Box {...dashboardSectionBody} px={dashboardPanelPadding.px}>
            No courses found
          </Box>
        )}
        {!!courses.length && (
          <DashboardCarousel flickingInset={learningHubDashboardCarouselInset}>
            {courses.map(course => (
              <DashboardCarouselPanel key={course.id}>
                <CourseCard bg="haze" {...course} />
              </DashboardCarouselPanel>
            ))}
          </DashboardCarousel>
        )}
      </Stack>
    </Stack>
  );
}
